import { PortalContextProvider } from '@talos/kyoko';
import lazyWithPrefetch from '@talos/kyoko/src/utils/lazyWithPrefetch';
import { Route, Routes } from 'react-router-dom';
import { ContextProvider } from '../../providers';

export const EmbeddedOrderForms = lazyWithPrefetch(() => import('@src/components/OMS/EmbeddedOrderForms'));
EmbeddedOrderForms.prefetch();

/** Routes to pages meant to be embedded with only internal navigation */
export function EmbeddedPages() {
  return (
    <ContextProvider>
      <PortalContextProvider>
        <Routes>
          <Route path="/order-forms" element={<EmbeddedOrderForms />} />
        </Routes>
      </PortalContextProvider>
    </ContextProvider>
  );
}
